/**
 * Dynamic route segments can preserve percent-encoding for valuation IDs.
 * Database IDs use the canonical, decoded form.
 */
export function normalizeValuationReportId(reportId: string): string {
  try {
    return decodeURIComponent(reportId);
  } catch {
    return reportId;
  }
}
